import axios from 'axios';

// Wrapper for the hierarchical categories-with-activities endpoint (backend
// TaskActivitiesLookupController.GetCategoriesWithActivities). Feeds the multiselect picker's
// grouped checkbox list — the flat lookup endpoint is unused now that the picker groups by
// category rather than paginating results.
//
// Omitting department returns the whole dictionary (each category tagged with its department) —
// the picker fetches it once and filters/searches client-side instead of one request per department.
export default class TaskActivityCategoriesService
{
    public static async getCategoriesWithActivities(department?: string): Promise<CategoryWithActivitiesModel[]>
    {
        return (await axios.get<CategoryWithActivitiesModel[]>('admin/renters/taskActivities/lookup/categories', {
            params: { department }
        })).data;
    }

    public static async addFavorite(activityPublicId: string): Promise<void>
    {
        await axios.put(`admin/renters/taskActivities/lookup/${activityPublicId}/favorite`);
    }

    public static async removeFavorite(activityPublicId: string): Promise<void>
    {
        await axios.delete(`admin/renters/taskActivities/lookup/${activityPublicId}/favorite`);
    }

    // HIR-320: department names in the order set in "Biblioteka czynności".
    public static async getDepartmentsOrder(): Promise<string[]>
    {
        return (await axios.get<string[]>('admin/renters/taskActivities/lookup/departments')).data;
    }
}

// Sorts department options by the admin-defined order; departments missing from it keep their
// relative order at the end.
export const sortByDepartmentOrder = <T extends { value: any }>(options: T[], order: string[]): T[] =>
{
    const position = (value: string): number => (order.includes(value) ? order.indexOf(value) : order.length);

    return [...options].sort((a, b) => position(a.value) - position(b.value));
};

export interface CategoryActivityItem
{
    publicId: string;
    name: string;
    isFavorite: boolean;
}

export interface CategoryWithActivitiesModel
{
    publicId: string;
    name: string;
    department: string;
    activities: CategoryActivityItem[];
}
